/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module DataModelModule
 */

import { ListCollDataSource } from './list-coll-data-source.factory';

export class LimitedListCollDataSource extends ListCollDataSource {}

Object.assign(LimitedListCollDataSource.prototype, {
    hasSearch: false,
    hasSorting: false,
    hasPagination: false,
});
